import {
  Dashboard,
  Roles,
  Members,
  LogOut,
  Devices,
  FleetRoutes,
  Orders,
  Vehicles,
  Requests,
  FuelMgt,
  Inventory,
  Finance,
  Reports,
  Monitoring,
  CompanySettings,
  Warehouses,
  UserLogs,
  OtherExpenses,
  Shipment,
  Suppliers,
  Customers,
} from "../../Components/Sidebar/sections";

function Sidebar() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col overflow-y-auto space-y-2 flex-grow">
        <Dashboard />
        <Vehicles />
        <Devices />
        <FleetRoutes />
        <FuelMgt />
        <Monitoring />

        <Orders />
        <Warehouses />
        <Requests />
        <Inventory />
        <OtherExpenses />
        <Shipment />
        <Finance />
        <Reports />
        <Customers />
        <Suppliers />
        <Roles />
        <Members />
        <UserLogs />
        <CompanySettings />
      </div>
      <div className="mt-auto">
        <LogOut />
      </div>
    </div>
  );
}

export default Sidebar;
